// Domínio definitivo do site (fonte única de verdade para SEO).
// Usar sempre com protocolo e SEM "www".
export const SITE_ORIGIN = 'https://nexussaude.com.br';

// Caminhos que devem ser indexados pelos buscadores (espelha o sitemap.xml).
export const INDEXABLE_PATHS: string[] = [
  '/',
  '/pgr-pcmsco',
  '/agendamento-exames-ocupacionais',
  '/terceirizacao-sst',
  '/gestao-afastados-absenteismo',
  '/saude-mental-corporativa',
  '/solucoes/saude-corporativa',
  '/solucoes/painel-gerenciador',
  '/solucoes/gestao-afastados',
  '/solucoes/implantacao-ambulatorios',
  '/solucoes/mapeamento-nr1',
  '/solucoes/treinamentos-nr',
  '/solucoes/entrega-epi',
  '/solucoes/assistencia-medica',
  '/solucoes/saude-mental',
  '/solucoes/nexia',
  '/sobre-nos',
  '/novidades-nexus',
  '/contato',
  '/area-do-cliente',
  '/politica-de-privacidade',
  '/credenciado',
];

// Normaliza o path: remove query/hash e barras finais (exceto a raiz).
export const normalizePath = (pathname: string): string => {
  const withoutQuery = pathname.split('?')[0].split('#')[0];
  if (!withoutQuery || withoutQuery === '/') return '/';
  return withoutQuery.replace(/\/+$/, '');
};

// Monta a URL canônica absoluta a partir de um path.
export const buildCanonicalUrl = (pathname: string): string => {
  const clean = normalizePath(pathname);
  return clean === '/' ? `${SITE_ORIGIN}/` : `${SITE_ORIGIN}${clean}`;
};

// Áreas administrativas nunca devem ser indexadas.
export const isAdminPath = (pathname: string): boolean =>
  normalizePath(pathname).startsWith('/admin');

// Matérias do blog são dinâmicas: cada slug é indexável por si só.
export const isBlogDetailPath = (pathname: string): boolean =>
  normalizePath(pathname).startsWith('/novidades-nexus/');

// Decide se a rota atual pode ser indexada.
export const isIndexablePath = (pathname: string): boolean => {
  const clean = normalizePath(pathname);
  if (isAdminPath(clean)) return false;
  if (isBlogDetailPath(clean)) return true;
  return INDEXABLE_PATHS.includes(clean);
};